export const hairStyleOptions = [
  { value: 'normal', label: 'Franja' },
  { value: 'thick', label: 'Topete' },
  { value: 'mohawk', label: 'Moicano' },
  { value: 'womanLong', label: 'Longo' },
  { value: 'womanShort', label: 'Curto' },
];

export const eyesOptions = [
  { value: 'circle', label: 'Redondo' },
  { value: 'oval', label: 'Oval' },
  { value: 'smile', label: 'Apertado' },
];

export const noseOptions = [
  { value: 'short', label: 'Curto' },
  { value: 'long', label: 'Longo' },
  { value: 'round', label: 'Redondo' },
];

export const mouthOptions = [
  { value: 'laugh', label: 'Rindo' },
  { value: 'smile', label: 'Sorrindo' },
  { value: 'peace', label: 'Feliz' },
];

export const glassesOptions = [
  { value: 'none', label: 'Nenhum' },
  { value: 'round', label: 'Redondo' },
  { value: 'square', label: 'Quadrado' },
];

export const hatStyleOptions = [
  { value: 'none', label: 'Nenhum' },
  { value: 'beanie', label: 'Gorro' },
  { value: 'turban', label: 'Turbante' },
];

export const shirtOptions = [
  { value: 'hoody', label: 'Moletom' },
  { value: 'short', label: 'Camiseta' },
  { value: 'polo', label: 'Polo' },
];

export const earSizeOptions = [
  { value: 'small', label: 'Pequeno' },
  { value: 'big', label: 'Grande' },
];

export const sexOptions = [
  { value: 'man', label: 'Homem' },
  { value: 'woman', label: 'Mulher' },
];
